import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';
import { useGetPayerMixReimbursementV2Query } from 'src/api/redux';
import { useProfileSelections } from '../profiles';

interface UseGetPayerMixReimbursementProps {
  providerId: string;
  payer_name?: string;
  payer_type?: string;
  location?: string;
  filterSetId?: number;
}

const useGetPayerMixReimbursement = ({
  providerId,
  payer_name,
  payer_type,
  location,
  filterSetId,
}: UseGetPayerMixReimbursementProps) => {
  const { selectedFilterSet } = useProfileSelections(location);

  const resolvedFilterSetId = filterSetId ?? selectedFilterSet?.id;
  const params = { filter_set: resolvedFilterSetId };

  const queryParams = getSearchQueryParamsForAPI({
    payer_name,
    payer_type,
    ...params,
  });

  const shouldFetch = !!location && !!providerId && !!resolvedFilterSetId;

  const { data, error, isLoading, isFetching } =
    useGetPayerMixReimbursementV2Query(
      { providerId, queryParams },
      { skip: !shouldFetch }
    );

  return {
    data,
    error,
    isLoading,
    isValidating: isFetching,
  };
};

export default useGetPayerMixReimbursement;
